import {Currency} from "@core/shared/models/currency";
import {SocietyValidationAccount} from "@core/shared/models/society-validation-account";

export enum RecipientStatus {
    ACTIVE = "active",
    CANCELED = "canceled",
    WAITING = "waiting",
    DEACTIVATED = "deactivated",
}

export interface Recipient {

    ownerName: string;

    address: RecipientAddress;

    bankTransfer: RecipientBankTransfer;

    validationAccount: SocietyValidationAccount;

    status: RecipientStatus;
}

export interface RecipientAddress {

    address: string;

    additionalAddress: string;

    city: string;

    region: string;

    zipcode: string;

    country: string;
}

export interface RecipientBankTransfer {

    iban: string;

    bic: string;

    currency: Currency;
}
